import { forwardRef, type Ref, type SVGProps } from "react";

function SvgTiersRedLock(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg ref={ref} xmlns="http://www.w3.org/2000/svg" width={55} height={54} fill="none" {...props}>
      <path
        fill="#B01921"
        d="M.38 3.538 6.647.09a.73.73 0 0 1 .706 0l6.267 3.447a.733.733 0 0 1 .25 1.058l-6.267 9.087a.732.732 0 0 1-1.206 0L.13 4.597a.733.733 0 0 1 .25-1.06Z"
      />
      <path stroke="#0C1C43" strokeLinecap="round" d="M33 33v7" />
      <path
        stroke="url(#TiersRedLock_svg__a)"
        strokeWidth={5}
        d="M22.143 21.667v-8C22.143 7.776 27.003 3 33 3s10.857 4.776 10.857 10.667v2.583M19.43 51h27.14c3 0 5.43-2.388 5.43-5.333V27c0-2.945-2.43-5.333-5.429-5.333H19.43c-3 0-5.43 2.387-5.43 5.333v18.667C14 48.612 16.43 51 19.429 51Z"
      />
      <defs>
        <linearGradient
          id="TiersRedLock_svg__a"
          x1={33}
          x2={33}
          y1={3}
          y2={51}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.195} stopColor="#FCBDC1" />
          <stop offset={1} stopColor="#F6F3F1" />
        </linearGradient>
      </defs>
    </svg>
  );
}
const ForwardRef = forwardRef(SvgTiersRedLock);
export default ForwardRef;
